import React from 'react';
import PauseSurvey from '../cancel/PauseSurvey';
import { useTeamModal } from '../../../hooks/subscriptions/useTeamModal';
import AccountPageConstants from 'constants/AccountPageConstants';

/**
 * First step in the pause/cancel flow - survey about why they're leaving
 */
const BillingModalPauseSurvey = ({ choice, onChoiceChange }) => {
  const { navigateToPage } = useTeamModal();

  const handleNext = () => {
    if (choice) {
      navigateToPage(AccountPageConstants.PAUSE_FEEDBACK_DETAIL);
    }
  };

  const handleCancel = () => {
    navigateToPage(AccountPageConstants.PLAN_AND_BILLING);
  };

  return (
    <PauseSurvey
      checked={choice}
      onChecked={onChoiceChange}
      onNext={handleNext}
      onCancel={handleCancel}
    />
  );
};

export default BillingModalPauseSurvey;